





































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  FireSafetyData, emptyData, getInfo, putData, postData
} from '@/api/unitBuiltFireSafety/fireSafety'
import { validateTel } from '@/configs/validate'
import { DDLItem } from '@/api/common/select'
import { splitToIntList } from '@/configs/functions'
import { PopUnitData } from '@/api/heritageUnit/heritageUnit'
import hspGallery from '@/components/upload/gallery.vue'
import PageForm from '@/components/pageLayout/form.vue'
import UnitSearchForm from '@/components/heritageUnit/search/index.vue'

import { namespace } from 'vuex-class'
const DataSourceModule = namespace('dataSource')

const getFormRules = (id: number, form: { [key: string]: string }) => {
  return {
    UnitName: [{ required: true, message: '请选择文保单位' }],
    UnitLocation: [{ required: true, message: '请输入文物所在位置', trigger: 'blur' }],
    ManageTel: [{ validator: validateTel, trigger: 'blur' }],
    BuildingCount: [{ type: 'number', message: '文物建筑数量必须为数字', trigger: 'blur' }],
    FloorCount: [{ type: 'number', message: '层数必须为数字', trigger: 'blur' }],
    FloorArea: [{ type: 'number', message: '占地面积必须为数字', trigger: 'blur' }],
    BuildArea: [{ type: 'number', message: '总建筑面积必须为数字', trigger: 'blur' }],
    BuildHeight: [{ type: 'number', message: '高度必须为数字', trigger: 'blur' }],
    SeparateDistance: [{ type: 'number', message: '分隔间距必须为数字', trigger: 'blur' }],
    'HS.OtherCombustibleReserves': [{ type: 'number', message: '周边可燃物堆场储量必须为数字', trigger: 'blur' }],
    'HS.OtherCombustibleDistance': [{ type: 'number', message: '周边可燃物堆场距离必须为数字', trigger: 'blur' }],
    'HS.OtherExplosiveReserves': [{ type: 'number', message: '周边易爆品储量必须为数字', trigger: 'blur' }],
    'HS.OtherExplosiveDistance': [{ type: 'number', message: '周边易爆品距离必须为数字', trigger: 'blur' }],
    'HS.OtherHazardousReserves': [{ type: 'number', message: '周边危化品储量必须为数字', trigger: 'blur' }],
    'HS.OtherHazardousDistance': [{ type: 'number', message: '周边危化品距离必须为数字', trigger: 'blur' }],
    'HS.OtherForest': [{ type: 'number', message: '周边森林间距必须为数字', trigger: 'blur' }],
    'HS.OtherGrassland': [{ type: 'number', message: '周边草场间距必须为数字', trigger: 'blur' }],
    'FL.FpCount': [{ type: 'number', message: '消防水池数量必须为数字', trigger: 'blur' }],
    'FL.FpVolume': [{ type: 'number', message: '消防水池总体积必须为数字', trigger: 'blur' }],
    'FL.ChPressure': [{ type: 'number', message: '市政消火栓压力必须为数字', trigger: 'blur' }],
    'FL.ChWater': [{ type: 'number', message: '市政消火栓水量必须为数字', trigger: 'blur' }],
    'FL.OhCount': [{ type: 'number', message: '室外消火栓数量必须为数字', trigger: 'blur' }],
    'FL.IhCount': [{ type: 'number', message: '室内消火栓数量必须为数字', trigger: 'blur' }],
    'MR.FtDistance': [{ type: 'number', message: '距离文物建筑的距离必须为数字', trigger: 'blur' }],
    'MR.FtTime': [{ type: 'number', message: '到达时间必须为数字', trigger: 'blur' }],
    'MR.FtNumber': [{ type: 'number', message: '消防队人数必须为数字', trigger: 'blur' }],
    'MR.FtPartTimeNumber': [{ type: 'number', message: '兼职消防队人数必须为数字', trigger: 'blur' }],
    'MR.FtDutyNumber': [{ type: 'number', message: '义务消防队人数必须为数字', trigger: 'blur' }],
    'MR.FtMotorPump': [{ type: 'number', message: '机动泵数必须为数字', trigger: 'blur' }],
    'MR.FtProtect': [{ type: 'number', message: '防护装备数必须为数字', trigger: 'blur' }],
    'MR.RoadWidth': [{ type: 'number', message: '路面宽度必须为数字', trigger: 'blur' }],
    'AC.HeTime': [{ type: 'number', message: '出水时间必须为数字', trigger: 'blur' }],
  }
}

@Component({
  components: {
    PageForm, UnitSearchForm, hspGallery
  }
})
export default class UnitBuiltFireSafetyForm extends Vue {
  public collapseNames: string[] = ['base', 'hs', 'fl', 'mr', 'ac']
  public textareaSize: any = { minRows: 3, maxRows: 6 }

  public form: FireSafetyData = Object.assign({}, emptyData)
  public loading = false

  public structureList: DDLItem[] = []
  public usageNatureList: DDLItem[] = []
  public layoutFormList: DDLItem[] = []
  public separateTypeList: DDLItem[] = []
  public separateByList: DDLItem[] = []
  public combustibleList: DDLItem[] = []
  public fireActionList: DDLItem[] = []
  public fuelTypeList: DDLItem[] = []
  public waterSupplyFormList: DDLItem[] = []
  public transferFormList: DDLItem[] = []
  public detectorTypeList: DDLItem[] = []
  public rules = getFormRules(0, this.form)

  get arrUsageNatureIds(): number[] {
    return splitToIntList(this.form.UsageNatureIds)
  }
  set arrUsageNatureIds(newVal: number[]) {
    this.form.UsageNatureIds = newVal.join(',')
  }
  get arrFireActions(): number[] {
    return splitToIntList(this.form.HS.FireActions)
  }
  set arrFireActions(newVal: number[]) {
    this.form.HS.FireActions = newVal.join(',')
  }
  get arrKitChenFuelTypes(): number[] {
    return splitToIntList(this.form.HS.KitChenFuelTypes)
  }
  set arrKitChenFuelTypes(newVal: number[]) {
    this.form.HS.KitChenFuelTypes = newVal.join(',')
  }
  get arrFaDetectorIds(): number[] {
    return splitToIntList(this.form.FL.FaDetectorIds)
  }
  set arrFaDetectorIds(newVal: number[]) {
    this.form.FL.FaDetectorIds = newVal.join(',')
  }
  // dynamic component
  public $refs!: {
    formCtrl: PageForm
    unitSearchCtrl: UnitSearchForm
  }
  public mounted() {
    window.eventBus.$on('submitUnitSearchForm', (data: PopUnitData[]) => {
      this.getUnit(data[0])
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('submitUnitSearchForm')
  }
  //#region 弹窗查询文保单位
  public openUnitSearch() {
    window.eventBus.$emit('openUnitSearchForm')
  }
  public getUnit(info: PopUnitData) {
    this.form.UnitId = info.UnitId
    this.form.UnitName = info.UnitName
    this.form.UnitCode = info.UnitCode
    this.form.LevelName = info.LevelName
    this.$refs.formCtrl.validateField('UnitName')
  }
  public closeUnitSearch() {
    console.log("这里是查询文保单位组件关闭后回传的事件")
  }
  public delUnit() {
    this.form.UnitId = 0
    this.form.UnitName = ''
    this.form.UnitCode = ''
    this.form.LevelName = ''
    this.$refs.formCtrl.validateField('UnitName')
  }
  //#endregion
  public created() {
    this.fetchSource()
    this.fetchData()
  }
  @DataSourceModule.Getter('dataSource')
  public dataSource!: any
  public fetchSource() {
    const data = Object.assign({}, this.dataSource)
    if (data) {
      this.structureList = data.structureList
      this.usageNatureList = data.usageNatureList
      this.layoutFormList = data.layoutFormList
      this.separateTypeList = data.separateTypeList
      this.separateByList = data.separateByList
      this.combustibleList = data.combustibleList
      this.fireActionList = data.fireActionList
      this.fuelTypeList = data.fuelTypeList
      this.waterSupplyFormList = data.waterSupplyFormList
      this.transferFormList = data.transferFormList
      this.detectorTypeList = data.detectorTypeList
    }
  }
  public fetchData() {
    const id = +this.$router.currentRoute.params.id || 0
    this.fetchForm(id)
  }
  public fetchForm(id: number) {
    this.loading = true
    getInfo(id).then((response: { data: any }) => {
      this.form = response.data
      this.rules = getFormRules(this.form.Id, this.form)
      if (this.form.Id == 0) {
        this.$refs.formCtrl.clearValidate()
      }
      this.loading = false
    })
  }
  public onCancel() {
    this.$router.push({ path: '/UnitBuiltFireSafety' })
  }

  public onTemp() {
    this.saveData(1)
  }
  public onSubmit() {
    this.saveData(2)
  }
  public saveData(status: number) {
    var f = Object.assign({}, this.form)
    //是否与周边其他建筑毗邻
    if (f.IsAdjacent) {
      f.SeparateType = 0
      f.SeparateDistance = 0
    }
    else {
      f.SeparateBy = 0
    }

    f.Status = status
    if (this.$refs.formCtrl.validate()) {
      const promist = f.Id > 0 ? putData(f.Id, f) : postData(f)
      promist.then(
        (response: { data: any }) => {
          const data = response.data
          const msg = f.Id > 0 ? '保存' : '创建'
          if (data && !data.IsError) {
            this.$message({
              message: `${msg}成功`,
              type: 'success'
            })
            this.$router.push({ path: '/UnitBuiltFireSafety' })
          } else {
            this.$message({
              dangerouslyUseHTMLString: true, message: `${data.Message}`, type: 'warning'
            })
            console.log(response)
          }
        })
    }
  }
  @Watch('$route')
  public onRouteChange(route: any) {
    this.fetchData()
  }
}
